import './oauthcb.css';
import { Link } from 'react-router-dom';

const OAuthCB=()=>{
	return (
		<div className="oauthcb-container">
			<div className="oauthcb-top">
				<h1>Caricamento in corso</h1>
			</div>
			<div className="oauthcb-body">
				<p>La preghiamo di attendere</p>
			</div>
		</div>
	);
};

export default OAuthCB;
